export default function parseDisplayName(displayName: {}) {
    // eslint-disable-next-line dot-notation
    return displayName['en'] ?? '';
}
